// "https://data.whicdn.com/images/322027365/original.jpg?t=1541703413",

const data = {
  name: "Stupid UwU",
  pfpUrl:
    "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  status: "From the top, make it drop, that's some WAP",
  watching: "Boruto: Naruto Next Generation ",
  totalEntries: 43,
  avgRating: 4.2,
  totalFriends: 67,
};

export default data;
